// extracted by mini-css-extract-plugin
export default {"hsSubNavigation":"SecondaryNavigation_hsSubNavigation__Lb5Hv","active":"SecondaryNavigation_active__eyMEH","show":"SecondaryNavigation_show__ctPQe"};